import React, { useState, useCallback, useEffect, useRef } from 'react';
import * as MESSAGE from '../../../../common/constants/message';
import * as TRANSLATE from '../../../../common/constants/live/translate';

export default function TranslateButton (props) {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);

  useEffect(() => {
    if(props.focus) {
      buttonRef.current.focus();
      props.onChangeFocus(null); 
    }
  }, [props.focus]);

  const handleClick = useCallback((event) => {
      if (TRANSLATE.SUPPORT_CHANNELS.indexOf(props.channelid) > -1) {
        setOpen(!open);
        props.onClick(open);
      } else {
        alert(MESSAGE.ALERT_LIVE_NOT_SUPPORT_TRANSLATE)
      }
    }, [open]);



  return (
    <div className={`live_btn_translate ${open ? 'current' : ''}`}>
      <button
        ref={buttonRef}
        className='live_link_cont'
        title={`${(TRANSLATE.SUPPORT_CHANNELS.indexOf(props.channelid) > -1) ? '번역' : MESSAGE.ALERT_LIVE_NOT_SUPPORT_TRANSLATE}`}
        aria-label={open ? '번역 숨기기' : '번역 표시'}
        onClick={handleClick.bind(this, 'translate')}
      >
        <span className='live_btn_icon'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='38.004'
            height='26.017'
            viewBox='0 0 38.004 26.017'
          >
            <g transform='translate(-697.546 -498.728)'>
              <path d='M706.591,516.186h0l-7.046-.019.007-15.314h18.163a1,1,0,0,0,0-2H699.546a2.015,2.015,0,0,0-2,2.02v15.288a2.016,2.016,0,0,0,2.006,2.025h7.039a1,1,0,0,0,0-2Z'></path>
              <path d='M733.546,505.353H726.5a1,1,0,0,0,0,2l7.045.02,0,15.314H714.429a1,1,0,0,0,0,2H733.55a2.012,2.012,0,0,0,2-2.02V507.379A2.015,2.015,0,0,0,733.546,505.353Z'></path>
              <path d='M723.549,498.864h0a1,1,0,0,0-1.368.36h0l-14,24a1,1,0,1,0,1.708,1.041l.019-.033,14-24A1,1,0,0,0,723.549,498.864Z'></path>
              <path d='M708.045,504.411h-2.137a.753.753,0,0,0-.717.531l-1.988,6.5a.75.75,0,1,0,1.434.44l.436-1.425h3.814a.713.713,0,0,0,.21-.042l.526,1.5a.75.75,0,1,0,1.415-.5l-2.286-6.5A.75.75,0,0,0,708.045,504.411Zm-2.513,4.545.931-3.045h1.051l1.07,3.045Z'></path>
              <path d='M720.989,512.069a.75.75,0,0,0,0,1.5h2.262l.063.827c-.02.489-.064,1.5-2.56,2.33a.749.749,0,0,0,.235,1.461.7.7,0,0,0,.235-.038c2.375-.784,3.515-1.957,3.587-3.775l-.118-1.61a.751.751,0,0,0-.748-.7Z'></path>
              <path d='M727.081,510.749a.75.75,0,0,0-.75.75v7.259a.75.75,0,0,0,1.5,0v-2.785h1.7a.75.75,0,0,0,0-1.5h-1.7V511.5A.75.75,0,0,0,727.081,510.749Z'></path>
            </g>
          </svg>
          <i className='hide'>번역</i>
        </span>
      </button>
    </div>
  );
}
